import { render, staticRenderFns } from "./SearchProductTag.vue?vue&type=template&id=37dd7197&scoped=true&"
import script from "./SearchProductTag.vue?vue&type=script&lang=js&"
export * from "./SearchProductTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dd7197",
  null
  
)

export default component.exports